<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from 'axios';
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Trial Balance",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Trial Balance",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Trial Balance",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },        
        {
          key: "account",
          sortable: true,
          label: "ACCOUNT NAME",
        },
        {
          key: "dr",
          sortable: true,
          label: "DEBIT",
        },
        {
          key: "cr",
          sortable: true,
          label: "CREDIT",
        }
        
      ],
      // Value from user input for adding category
      data: {
        credit: "",
        debit: "",
        amount: "",
        type:26,
        date: moment(new Date()).format("YYYY-MM-DD"),
        filterData:{}
      },
      
      // make inputs required
      creditError: "",
      debitError: "",
      amountError: "",
      TypeError:"",
      // delete category
      deletedata: {
        name: "",
        id: "",
      },
      filterData: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        branch_id:0
      },
      total_credit:0,
      total_debit:0,
      SelectOptions:[
        // {title:'Deposit Transaction', value:'23'},
        // {title:'Withdraw Transaction', value:'24'},
        // {title:'Revenue Transaction', value:'25'},
        {title:'Other Transactions', value:'26'}
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("coa", ["Transactions", "Accounts", "AccountSaveStatus", "filterStatus"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["PaymentOptions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Transactions ? this.Transactions.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Transactions ? this.Transactions.length : 1;
  },
  updated(){
    let total_credit = 0;
    let total_debit = 0;
      // let total_paid = 0;
      if(this.Transactions){
        this.Transactions.forEach((item)=>{
          if(parseInt(item.diff) >= 0){
            total_debit = total_debit+parseInt(item.diff);
          }else{
            total_credit = total_credit+parseInt(item.diff);
          }
        });
        this.total_debit = total_debit;
        this.total_credit = total_credit;
      }
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      AddTransaction: "coa/SaveTransaction",
      EditTransaction: "coa/EditTransaction",
      DeleteTransaction: "coa/DeleteTransaction",
      FetchTrialBalance: "coa/fetchTrialBalance",
      FetchAccounts: "coa/fetchAccounts",
      FetchModes: "setting/fetchPaymentOptions",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    Addtransaction(modalId) {
      this.modal_id = modalId;

      if (this.data.debit === "") {
        this.debitError = "Account debited field is required";
        return;
      } else {
        this.debitError = "";
      }
      if (this.data.credit === "") {
        this.creditError = "Account credited field is required";
        return;
      } else {
        this.creditError = "";
      }
      if (this.data.type === "") {
        this.TypeError = "Transaction type field is required";
        return;
      } else {
        this.TypeError = "";
      }
      if (this.data.amount === "") {
        this.amountError = "Amount is required";
        return;
      } else {
        this.amountError = "";
      }
      this.data.filterData = this.filterData;
      this.AddTransaction(this.data)
    },

    resetAddTrans() {
      this.data.debit = "";
      this.data.credit = "";
      this.data.amount = "";
      this.data.type = 26;
      this.debitError = "";
      this.creditError = "";
      this.TypeError = "";
      this.modal_id = "";
    },

    resetErrors() {
        this.acountError = "";
        this.amountError = "";
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    FetchTransactions(){
      this.FetchTrialBalance(this.filterData);
    },

    Excel_export() {
      axios
        .post("export_tb", this.filterData,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "trial_balance.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },

    addComma(){
      this.data.amount = this.thousandSeperator(this.data.amount);
    }
  },
  created() {
    this.FetchTrialBalance(this.filterData);
    this.FetchModes();
    this.FetchAccounts();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <h3 class="card-title mb-4 text-center">TRIAL BALANCE AS OF {{filterData.date}}</h3>
            </div> 
            <div class="row">  
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-file-excel"></i> Export</b-button
                >
              </div> 
              <div class="col-md-3">
                <label>FILTER AS OF</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.date"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                />
              </div>
              <div class="col-md-3 mt-4" align="right">
                <button class="btn btn-warning" type="button" @click="FetchTransactions()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-button
                  class="float-end"
                  variant="primary"
                  v-b-modal.add-transaction-modal
                  ><i class="fa fa-plus"></i> Record New Transaction</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Transactions ? Transactions : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(account)="data">
                  <router-link :to="`/transaction_details/${data.item.account}`">
                    {{ (data.item.accounts.name) }}
                  </router-link>                  
                </template>
                <template #cell(dr)="data">
                  <div v-if="data.item && (data.item.diff)>=0">
                    {{ thousandSeperator(data.item.diff) }}
                  </div>
                </template>
                <template #cell(cr)="data">
                  <div v-if="data.item && (data.item.diff)<0">
                    {{ thousandSeperator(data.item.diff) }}
                  </div>
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>Total Debit: <span class="text-primary">{{thousandSeperator(total_debit)}}</span></h5>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>Total Credit: <span class="text-danger">{{thousandSeperator(total_credit)}}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!Transactions"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add expense modal starts -->
            <b-modal id="add-transaction-modal" hide-footer @hidden="resetAddTrans">
              <template #modal-title> Record New Transaction</template> 
              <div class="form-group mb-3">
                <label>Transaction type</label>
                <model-list-select
                  :list="SelectOptions ? SelectOptions : []"
                  v-model="data.type"
                  option-value="value"
                  option-text="title"
                  placeholder="Select Type"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="TypeError">
                  <em>{{ TypeError }}</em>
                </div>
              </div>            
              <div class="form-group mb-3">
                <label>Account Debited</label>
                <model-list-select
                  :list="Accounts ? Accounts : []"
                  v-model="data.debit"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Account"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="debitError">
                  <em>{{ debitError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Account Credited</label>
                <model-list-select
                  :list="Accounts ? Accounts : []"
                  v-model="data.credit"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Account"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="creditError">
                  <em>{{ creditError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.amount"
                    @input="resetErrors(), addComma()"
                    placeholder="Enter Amount"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>  
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="data.date"
                  />
                </div>
              </div>        
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-transaction-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="Addtransaction('add-transaction-modal')"
                >
                  <i class="fa fa-check"></i> Save Account
                  <b-spinner
                    v-if="AccountSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
